module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_long_front_vector.5eb4e0e9.svg";